import { combineEpics } from 'redux-observable'

import { cryptoRewardsEpicCommon } from 'components/features/rewards/rewardsPane/store/epics/common'
import { rewardsPaneBuyModeEpic } from 'components/features/rewards/rewardsPane/store/epics/buyMode'
import { rewardsPaneSellModeEpic } from 'components/features/rewards/rewardsPane/store/epics/sellMode'
import { rewardsPaneAutoinvestmentsModeEpic } from 'components/features/rewards/rewardsPane/store/epics/autoInvestmentsMode'
import { cryptoRewardsEpicOrders } from 'components/features/rewards/rewardsPane/store/epics/orders'

export const rewardsPaneEpic = combineEpics(
  cryptoRewardsEpicCommon,
  cryptoRewardsEpicOrders,
  rewardsPaneBuyModeEpic,
  rewardsPaneSellModeEpic,
  rewardsPaneAutoinvestmentsModeEpic,
)
